import request from '@/utils/request'
import requestIO from '@/utils/requestIO'

export function getBadges(data) {
  return request({
    url: '/job/comm/getAllLabel',
    method: 'post',
    data
  })
}


export function uploadInnerFile(id) {
  let formData = new window.FormData()
  formData.append('file', document.getElementById(id).files[0])
  return request({
    url: '/dfs/file/uploadInnerFile',
    data:formData,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function upload(id) {
  let formData = new window.FormData()
  formData.append('file', document.getElementById(id).files[0])
  return request({
    url: '/dfs/file/upload',
    data:formData,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getTreeJobType() {
  return request({
    url: '/job/comm/getTreeJobType',
    method: 'get'
  })
}

export function getAllIndustry() {
  return request({
    url: '/job/comm/getAllIndustry',
    method: 'get'
  })
}

/**
 *获取图片
 * @param id
 * @returns {AxiosPromise}
 */
export function loadPic(id) {
  return requestIO({
    url: '/dfs/file/loadPic',
    method: 'get',
    params: {id: id},
    responseType:'arraybuffer'
  })
}
/**
 *获取文件
 * @param id
 * @returns {AxiosPromise}
 */
export function loadFile(id) {
  return requestIO({
    url: '/dfs/file/downInnerFile',
    method: 'get',
    params: {id: id},
    responseType:'arraybuffer'
  })
}
/**
 *获取文件objectId获取对应文件关联列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getFileLink(data) {
  return request({
    url: '/dfs/business/getBusinessFiles',
    method: 'post',
    data
  })
}

/**
 *保存文件关联关系
 * @param data
 * @returns {AxiosPromise}
 */
export function saveFileLink(data) {
  return request({
    url: '/dfs/file/insertLinks',
    method: 'post',
    data
  })
}

export function getBusinessFilesInfos(data) {
  return request({
    url: '/dfs/business/getBusinessFilesInfos',
    method: 'post',
    data
  })
}

/**
 *根据文件ID列表获取文件列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getFileList(data) {
  return request({
    url: '/dfs/file/getFileList',
    method: 'post',
    data
  })
}
/**
 *清理模块对应文件
 * @param data
 * @returns {AxiosPromise}
 */
export function clearBusinessFiles(data) {
  return request({
    url: '/dfs/file/clearBusinessFiles',
    method: 'post',
    data
  })
}

export function sendAliMsg(data) {
  return request({
    url: '/interface/sms/sendAliMsg',
    method: 'post',
    headers: {
      "hideLoading": true
    },
    data
  })
}

export function updateTelephone(data){
  return request({
    url: '/user/updateTelephone',
    method: 'post',
    data
  })
}

export function listEnterpriseLog(data){
  return request({
    url: '/job/log/listEnterpriseLog',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js